import { Button } from "@components/ui/button"
import { Skeleton } from "@components/ui/skeleton"
import { useProspectTitleSerializer } from "./useProspectTitleSerializer"
import { CardDataList } from "@components/CardDataList/CardDataList"
import { useMatch, useNavigate } from "react-router-dom"

type TProspectTitleProps = {
  prospect_guid: string
}

export const ProspectTitle = ({ prospect_guid }: TProspectTitleProps) => {
  const { data, isPending, isError } = useProspectTitleSerializer(prospect_guid)
  const navigate = useNavigate()
  const isProspectHomeRoute = !!useMatch("/prospect/:prospect_guid")

  const buttonElements = data.buttonItems.map((item, index) => {
    const { label, permissions, onClick } = item

    return (
      <Button
        key={`${label}-${index}`}
        variant="outline"
        size="sm"
        onClick={onClick}
        hidden={permissions}
      >
        {label}
      </Button>
    )
  })

  return (
    <div className="tw:grid tw:grid-cols-12 tw:gap-2">
      <div className="tw:col-span-12 tw:md:col-span-8">
        <div className="tw:flex tw:flex-col tw:gap-2">
          {isPending ? (
            <Skeleton className="tw:h-10 tw:w-96 tw:rounded-md" />
          ) : (
            data.prospectFullName && (
              <span className="tw:text-4xl">{data.prospectFullName}</span>
            )
          )}

          <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1">
            {!isProspectHomeRoute && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate(`/prospect/${prospect_guid}`)}
              >
                View Prospect
              </Button>
            )}
            {buttonElements}
          </div>
        </div>
      </div>
      <div className="tw:col-span-12 tw:md:col-span-4">
        <CardDataList items={data.headerItems} isError={isError} />
      </div>
    </div>
  )
}
